<template>
  <a-popover placement="bottomRight" trigger="click" overlay-class-name="crm-reminder-popover" @visibleChange="handleVisible">
    <template slot="content">
      <div class="reminder-panel">
        <div class="panel-head"><div><b>跟进待办</b><span>{{ summary.totalCount || 0 }} 项待处理</span></div><a @click="openAll">查看全部</a></div>
        <div v-if="loading" class="panel-state"><a-spin size="small" /> 正在加载</div>
        <a-empty v-else-if="!items.length" :image="simpleImage" description="暂无到期或逾期待办" class="panel-empty" />
        <template v-else>
          <button v-for="item in items" :key="item.objectType + ':' + item.objectId" class="reminder-item" type="button" @click="openItem(item)">
            <span class="status-dot" :class="item.reminderStatus" />
            <span class="item-body"><b>{{ item.objectName || '未命名对象' }}</b><small>{{ item.objectType === 'lead' ? '线索' : '客户' }} · {{ item.objectCode || '—' }}</small></span>
            <span class="item-time" :class="item.reminderStatus">{{ shortTime(item.nextFollowUpTime) }}<small>{{ item.reminderStatus === 'overdue' ? '已逾期' : '今日到期' }}</small></span>
          </button>
        </template>
        <div v-if="items.length" class="panel-foot"><span><i class="overdue-dot" />逾期 {{ summary.overdueCount || 0 }}</span><span><i class="due-dot" />今日 {{ summary.dueTodayCount || 0 }}</span></div>
      </div>
    </template>
    <a-tooltip placement="bottom" title="跟进待办">
      <span class="reminder-trigger" aria-label="跟进待办"><a-badge :count="summary.totalCount || 0" :overflow-count="99"><a-icon type="bell" /></a-badge></span>
    </a-tooltip>
  </a-popover>
</template>

<script>
import { Empty } from 'ant-design-vue'
import { getCrmReminderSummary } from '@/api/erp/crm'

export default {
  name: 'CrmReminderIcon',
  data () { return { loading: false, summary: { overdueCount: 0, dueTodayCount: 0, totalCount: 0, recentItems: [] }, timer: null, simpleImage: Empty.PRESENTED_IMAGE_SIMPLE } },
  computed: { items () { return this.summary.recentItems || [] } },
  mounted () { this.load(); this.timer = window.setInterval(this.load, 300000) },
  beforeDestroy () { if (this.timer) window.clearInterval(this.timer) },
  methods: {
    load () {
      this.loading = true
      return getCrmReminderSummary(5).then(res => { this.summary = res.data || this.summary }).catch(() => {}).finally(() => { this.loading = false })
    },
    handleVisible (visible) { if (visible) this.load() },
    openAll () { this.$router.push('/erp/crm/reminder') },
    openItem (item) { this.$router.push({ path: '/erp/crm/reminder', query: { objectType: item.objectType, keyword: item.objectCode } }) },
    shortTime (value) { return value ? String(value).replace('T', ' ').slice(5, 16) : '—' }
  }
}
</script>

<style lang="less" scoped>
.reminder-trigger { display: inline-flex; align-items: center; justify-content: center; min-width: 32px; height: 40px; color: rgba(0, 0, 0, .65); cursor: pointer; }
.reminder-trigger .anticon { font-size: 18px; }
.reminder-panel { width: 360px; margin: -4px -8px; }
.panel-head { display: flex; align-items: center; justify-content: space-between; padding: 10px 12px 12px; border-bottom: 1px solid #edf0f4; }
.panel-head div { display: flex; flex-direction: column; }
.panel-head b { color: #17233d; font-size: 15px; }
.panel-head span { color: #98a2b3; font-size: 12px; margin-top: 2px; }
.panel-state { padding: 30px; text-align: center; color: #98a2b3; }
.panel-empty { margin: 22px 0; }
.reminder-item { width: 100%; display: grid; grid-template-columns: 8px minmax(0, 1fr) 78px; gap: 10px; align-items: center; padding: 11px 12px; border: 0; border-bottom: 1px solid #f0f2f5; background: #fff; text-align: left; cursor: pointer; }
.reminder-item:hover { background: #f7faff; }
.status-dot { width: 7px; height: 7px; border-radius: 50%; background: #faad14; }
.status-dot.overdue { background: #ff4d4f; }
.item-body { display: flex; min-width: 0; flex-direction: column; }
.item-body b { overflow: hidden; color: #27364b; text-overflow: ellipsis; white-space: nowrap; }
.item-body small, .item-time small { color: #98a2b3; font-size: 12px; }
.item-time { display: flex; flex-direction: column; align-items: flex-end; color: #d46b08; font-size: 12px; }
.item-time.overdue { color: #cf1322; }
.panel-foot { display: flex; gap: 18px; padding: 10px 12px 6px; color: #7b8798; font-size: 12px; }
.panel-foot i { display: inline-block; width: 6px; height: 6px; margin-right: 6px; border-radius: 50%; }
.overdue-dot { background: #ff4d4f; }.due-dot { background: #faad14; }
</style>
